import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';
import { EditorModule } from 'primeng/editor';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { InputMaskModule } from 'primeng/inputmask';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { KeyFilterModule } from 'primeng/keyfilter';
import { MessageModule } from 'primeng/message';
import { PanelModule } from 'primeng/panel';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { ToolbarModule } from 'primeng/toolbar';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';

import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Title } from '@angular/platform-browser';
import { RouterModule, Routes } from '@angular/router';

import { ProgressComponent } from './progress.component';
import { ClassSelectorComponent } from './components/class-selector/class-selector.component';
import { CompetitorsListFilterSelectorComponent } from './components/competitors-list-filter-selector/competitors-list-filter-selector.component';
import { CompetitorsListFilterSelectorService } from './components/competitors-list-filter-selector/competitors-list-filter-selector.service';
import { DocumentsParticipantsTableComponent } from './components/documents/documents-participants-table/documents-participants-table.component';
import { DocumentsComponent } from './components/documents/documents.component';
import { MarkReturnedSensorsComponent } from './components/documents/mark-returned-sensors/mark-returned-sensors.component';
import { PartipianDocumentComponent } from './components/documents/partipian-documents/partipian-document/partipian-document.component';
import { PartipianDocumentsComponent } from './components/documents/partipian-documents/partipian-documents.component';
import { EditCompetitorComponent } from './components/edit-competitor/edit-competitor.component';
import { EditMarkComponent } from './components/edit-competitor/edit-mark/edit-mark.component';
import { FormDocumentsComponent } from './components/form-documents/form-documents.component';
import { FullImageComponent } from './components/full-image/full-image.component';
import { OvervalComponent } from './components/overval/overval.component';
import { ProgressListV2Component } from './components/progress-list-v2/progress-list-v2.component';
import { CompetitorInfoComponent } from './components/progress-list/competitor-info/competitor-info.component';
import { MarksTableComponent } from './components/progress-list/marks-table/marks-table/marks-table.component';
import { ProgressListComponent } from './components/progress-list/progress-list.component';
import { ProgressTableComponent } from './components/progress-list/progress-table/progress-table.component';
import { RacesInfoComponent } from './components/races-info/races-info.component';
import { SelectItemComponent } from './components/select-item/select-item.component';
import { TimeStateSelectorComponent } from './components/time-state-selector/time-state-selector.component';
import { DevNumberPipe } from '../../pipes/dev-number.pipe';
import { ImageService } from '../../services/image.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ProfileService } from 'src/app/services/profile.service';
import { RaceFileUploaderModule } from '../race-file-uploader/race-file-uploader.module';
import { RaceRegModule } from '../race-reg/race-reg.module';
import { RaceHoFModule } from '../race-hof/race-hof.module';
import { ProgressService } from 'src/app/services/progress.service';
import { SocketService } from 'src/app/services/socket.service';
import { DateMaskDirective } from 'src/app/directives/date-mask.directive';
import { SharedPipesModule } from 'src/app/shared-pipes.module';
import { UniversalComponentCardModule } from 'src/app/shared/components/universal-competitor-card/universal-components-card.module';

const routes: Routes = [
  { path: 'list', component: ProgressComponent },
];

@NgModule({
  declarations: [
    ProgressComponent,
    DateMaskDirective,
    ProgressListComponent,
    DocumentsComponent,
    OvervalComponent,
    DevNumberPipe,
    FormDocumentsComponent,
    ClassSelectorComponent,
    TimeStateSelectorComponent,
    RacesInfoComponent,
    ProgressListV2Component,
    EditCompetitorComponent,
    EditMarkComponent,
    DocumentsParticipantsTableComponent,
    MarkReturnedSensorsComponent,
    SelectItemComponent,
    MarksTableComponent,
    ProgressTableComponent,
    FullImageComponent,
    PartipianDocumentsComponent,
    PartipianDocumentComponent,
    CompetitorsListFilterSelectorComponent,
    CompetitorInfoComponent,
  ],
  imports: [
    SharedPipesModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    FileUploadModule,
    CalendarModule,
    ButtonModule,
    ToolbarModule,
    DialogModule,
    DropdownModule,
    TableModule,
    FieldsetModule,
    ToggleButtonModule,
    CheckboxModule,
    TriStateCheckboxModule,
    InputTextModule,
    ReactiveFormsModule,
    MessageModule,
    RadioButtonModule,
    InputSwitchModule,
    MatDatepickerModule,
    MatNativeDateModule,
    InputTextareaModule,
    TabViewModule,
    SplitButtonModule,
    MatToolbarModule,
    MatIconModule,
    PanelModule,
    DynamicDialogModule,
    RouterModule.forChild(routes),
    KeyFilterModule,
    ConfirmDialogModule,
    InputMaskModule,
    EditorModule,
    PdfViewerModule,
    RaceRegModule,
    RaceFileUploaderModule,
    RaceHoFModule,
    UniversalComponentCardModule,
  ],
  providers: [
    MatDatepickerModule,
    Title,
    CompetitorsListFilterSelectorService,
    SocketService,
    ProfileService,
    ImageService,
    ProgressService,
  ],
  bootstrap: [ProgressComponent],
})
export class ProgressModule {
}
